export const Dashicon3 = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 12C3 8.25027 3 6.3754 3.95491 5.06107C4.26331 4.6366 4.6366 4.26331 5.06107 3.95491C6.3754 3 8.25027 3 12 3C15.7497 3 17.6246 3 18.9389 3.95491C19.3634 4.26331 19.7367 4.6366 20.0451 5.06107C21 6.3754 21 8.25027 21 12C21 12.8389 21 13.584 20.9893 14.25L20.9192 14.25C20.0672 14.2499 19.5482 14.2499 19.1005 14.3208C16.6401 14.7105 14.7105 16.6401 14.3208 19.1005C14.2499 19.5482 14.2499 20.0672 14.25 20.9192L14.25 20.9893C13.584 21 12.8389 21 12 21C8.25027 21 6.3754 21 5.06107 20.0451C4.6366 19.7367 4.26331 19.3634 3.95491 18.9389C3 17.6246 3 15.7497 3 12ZM8 8.75L11 8.75C11.4142 8.75 11.75 8.41421 11.75 8C11.75 7.58579 11.4142 7.25 11 7.25L8 7.25C7.58579 7.25 7.25 7.58579 7.25 8C7.25 8.41421 7.58579 8.75 8 8.75ZM7.25 12C7.25 12.4142 7.58579 12.75 8 12.75L16 12.75C16.4142 12.75 16.75 12.4142 16.75 12C16.75 11.5858 16.4142 11.25 16 11.25L8 11.25C7.58579 11.25 7.25 11.5858 7.25 12Z"
          fill="#5FABDB"
        />
        <path
          d="M19.3352 15.8023C19.6435 15.7535 20.0243 15.7501 20.9347 15.75C20.8403 17.1896 20.6094 18.1622 20.0451 18.9389C19.7367 19.3634 19.3634 19.7367 18.9389 20.0451C18.1622 20.6094 17.1896 20.8403 15.75 20.9347C15.7501 20.0243 15.7535 19.6435 15.8023 19.3352C16.0904 17.5166 17.5166 16.0904 19.3352 15.8023Z"
          fill="#5FABDB"
        />
      </svg>
    </>
  );
};
